import { useRef, useEffect } from "react";
import ReactTypingEffect from "react-typing-effect";
import { Link } from "react-router-dom";
import LearnMoreBtn from "./LearnMoreBtn";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SecondDiv = () => {
  let secondDivRef = useRef(null);

  useEffect(() => {
    gsap.to(secondDivRef.current, {
      opacity: 1,
      scale: 0.9,
      duration: 1,
      scrollTrigger: {
        trigger: secondDivRef.current,
        start: "top",
        end: "center",
        toggleActions: "play reverse play reverse",
      },
    });
  });

  return (
    <div className="second_div" ref={secondDivRef}>
      <ReactTypingEffect
        speed={100}
        eraseDelay={5000}
        cursorRenderer={(cursor) => <p style={{ display: "none" }}>{cursor}</p>}
        text={
          "Above is a young but powerful company which will take you as far as you can see when looking in the night sky..."
        }
        displayTextRenderer={(txt, i) => {
          return <h2 className="secondDiv_h2">{txt}</h2>;
        }}
      />
      <Link to="/AboutPage">
        <LearnMoreBtn topStyle="70%" leftStyle="50%" />
      </Link>
    </div>
  );
};

export default SecondDiv;
